require('bootstrap');
require('./lag-popover');

module.exports = {
    BootstrapDialog: require('./bootstrap-dialog')
};


//////////////////
// WEBPACK FOOTER
// ./src/bootstrap/index.js
// module id = 78
// module chunks = 0